<template>
  <card>
    <div slot="header">
      <h4 class="title">Edit Profile</h4>
    </div>
    <div>
      <form>
        <div class="row">
          <div class="col-md-6">
            <fg-input
              type="text"
              label="First Name"
              placeholder="First Name"
              v-model="user.firstName"
            ></fg-input>
          </div>
          <div class="col-md-6">
            <fg-input type="text" label="Last Name" placeholder="Last Name" v-model="user.lastName"></fg-input>
          </div>
          <el-input
            class="about-me"
            type="textarea"
            :autosize="{ minRows: 3}"
            placeholder="About Me"
            v-model="user.aboutMe"
          ></el-input>
        </div>
        <br />
        <div class="text-center">
          <button
            type="submit"
            class="btn btn-info btn-fill btn-wd"
            @click.prevent="updateProfile"
          >Update Profile</button>
          <button type="submit" class="btn btn-info btn-fill btn-wd clear-my-data">Clear My Data</button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
import api from "../../../../axios_api";

export default {
  name: "edit-profile-form",
  created() {
    this.getUser();
  },
  data() {
    return {
      user: {}
    };
  },
  methods: {
    updateProfile() {
      let payload = {
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        aboutMe: this.user.aboutMe
      };

      api
        .patch("/user", { data: payload })
        .then(res => {
          let user = res.data.encrypt.success;
          this.$store.commit("user/first_name", { first_name: user.firstName });
          this.$store.commit("user/last_name", { last_name: user.lastName });
          this.$router.go(-1);
        })
        .catch(err => {
          return Promise.reject(err);
        });
    },
    getUser() {
      api
        .get("/user")
        .then(res => {
          this.user = res.data;
          return this.user;
        })
        .catch(err => {
          return Promise.reject(err);
        });
    }
  }
};
</script>
<style>
.about-me {
  margin: 0 16px;
  width: 94%;
}
</style>
